import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Text,
  Tooltip,
} from '@chakra-ui/react'
import { AiFillPlusCircle } from 'react-icons/ai'
import { api } from '../../../../services/api'
import { useQuery } from 'react-query'
import { Table, Tbody, Td, Th, Thead, Tr } from '../../../../components/Table'
import { format } from 'date-fns'

async function getNFData() {
  const response = await api.post('/site/v2/categoria/listar-informacoes-tela-info-p-nota', {
    codigo_parceiro: '',
    numero_pedido: '',
    data_entrada: '',
    data_saida: '',
    pendente: '',
    nfe: '',
  })

  return response.data.map((data) => {
    return {
      ...data,
      cod_parc: data.cod_parc,
      data_pronto: data.data_pronto,
      data_saida: data.data_saida ? format(new Date(data.data_saida), 'dd/MM/yyyy HH:mm') : '',
      tipo_envio: data.tipo_transporte,
      nome_parc: data.nome_parc,
      nome_vendedor: data.nome_vendedor,
      numero_pedido: data.numero_pedido,
      numero_unico: data.numero_pedido,
      numero_nota: data.numero_nota,
      numero_nota_show: data.numero_nota,
      peso_total: data.peso_total,
      quantidades_caixa: data.quantidades_caixa,
      status_pendencia: data.status_pendencia,
      data_atualizacao: data.data_atualizacao,
      nota_remessa: data.nota_remessa,
      remessa: data.remessa,
      link_boleto: data.link_boleto,
      codigo_produto: data.codigo_produto,
      sequencia: data.sequencia,
      valida_etiqueta: data.valida_etiqueta,
      codigo_kangu: data.codigo_kangu,
      boletos: data.boletos,
      link_layout: data.link_layout,
      saida_materiais: data.data_saida ? format(new Date(data.data_saida), 'dd/MM/yyyy HH:mm') : '',
      limite_producao: data.data_limite ? format(new Date(data.data_limite), 'dd/MM/yyyy HH:mm') : '',
    }
  })
}

export function MaisNFModal() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const { data, isLoading } = useQuery({
    queryKey: 'nfData',
    queryFn: getNFData,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10,
  })

  console.log(data)

  return (
    <>
      <Button leftIcon={AiFillPlusCircle} colorScheme="blue" variant="solid" size="md" marginLeft={'1rem'} mb={'1rem'} onClick={onOpen}>
        + NF
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Informações de Notas Fiscais</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table>
              <Thead>
                <Tr>
                  <Th>Nº Pedido</Th>
                  <Th>Nome do Cliente</Th>
                  <Th>Nome Vendedor</Th>
                  <Th>QTD de Caixas</Th>
                  <Th>Transp</Th>
                </Tr>
              </Thead>
              <Tbody>
                {isLoading ? (
                  <Tr>
                    <Th colSpan={6}>Carregando...</Th>
                  </Tr>
                ) : data?.length === 0 ? (
                  <Tr>
                    <Th colSpan={6}>Nenhum dado encontrado</Th>
                  </Tr>
                ) : (
                  data.map((item) => (
                    <Tr key={item.numero_pedido}>
                      <Td>{item.numero_pedido}</Td>
                      <Td>
                        <Tooltip label={item.nome_parc} aria-label="A tooltip" bg="gray.300" color="black" placement="top" hasArrow>
                          <Text isTruncated w="300px">
                            {item.nome_parc}
                          </Text>
                        </Tooltip>
                      </Td>
                      <Td>{item.nome_vendedor}</Td>
                      <Td>{item.quantidades_caixa}</Td>
                      <Td>
                        <Tooltip label={item.transportadora} aria-label="A tooltip" bg="gray.300" color="black" placement="top" hasArrow>
                          <Text isTruncated w="80px">
                            {item.transportadora}
                          </Text>
                        </Tooltip>
                      </Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
